var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-meta/reviews-empty.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["quickshop.hideReviews",""]));
frame.set("displayReviews", t_1, true);
if(frame.topLevel) {
context.setVariable("displayReviews", t_1);
}
if(frame.topLevel) {
context.addExport("displayReviews", t_1);
}
if(!runtime.contextOrFrameLookup(context, frame, "displayReviews")) {
output += "\n\n    <span class=\"c-star-review-outer has-no-reviews\">\n    ";
output += "\n        <span class=\"c-star-review\">";
output += runtime.suppressValue((lineno = 6, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-stars-empty"])), env.opts.autoescape);
output += "</span></span><span class=\"c-product-reviews__count has-no-reviews\">";
if(runtime.contextOrFrameLookup(context, frame, "quickshop") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += runtime.suppressValue((lineno = 9, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["quickshop_meta-reviews-empty"])), env.opts.autoescape);
;
}
else {
output += "\n            <a ";
output += runtime.suppressValue((lineno = 14, colno = 18, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["pdp",runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"analytics")),"productTypeSlug"),"reviews"])), env.opts.autoescape);
output += " class=\"c-product-reviews__count-link js-product-reviews__count\" href=\"#\">";
output += runtime.suppressValue((lineno = 14, colno = 148, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_meta-reviews-empty"])), env.opts.autoescape);
output += "</a>";
;
}
output += "</span>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-meta/reviews-empty.j2"] , dependencies)